/**
 * PAPI Status Tracking
 * Lightweight module for observable PAPI initialization status.
 * Separated from papi.client.ts so that PapiProvider can subscribe
 * to status changes without pulling in the heavy Smoldot/WASM dependency chain.
 */

import type { PapiStatus } from '@/types';

let papiStatus: PapiStatus = 'idle';
const statusListeners = new Set<(status: PapiStatus) => void>();

/**
 * Update PAPI status and notify all subscribers.
 * Called by papi.client.ts during initialization lifecycle.
 */
export function setStatus(status: PapiStatus) {
	papiStatus = status;
	statusListeners.forEach((cb) => cb(status));
}

/**
 * Get current PAPI initialization status
 */
export function getPapiStatus(): PapiStatus {
	return papiStatus;
}

/**
 * Subscribe to PAPI status changes
 * @returns Unsubscribe function
 */
export function subscribeToPapiStatus(callback: (status: PapiStatus) => void): () => void {
	statusListeners.add(callback);
	return () => statusListeners.delete(callback);
}
